export default "__VITE_PUBLIC_ASSET__f50ea52b__"